import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import type {User} from '@github-ui/user-selector'
import {Link} from '@primer/react'

import {useActivityAnalytics} from '../hooks/use-activity-analytics'
import styles from './Pusher.module.css'

export function Pusher({pusher}: {pusher: User}) {
  const {sendActivityClickEvent} = useActivityAnalytics()
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  return (
    <Link
      aria-label={`View ${pusher.login} profile`}
      muted
      href={pusher.path}
      {...getHovercardAttributesForType('user', {login: pusher.login})}
      onClick={() => sendActivityClickEvent('PUSHER_LINK')}
      className={styles.pusherLink}
    >
      <GitHubAvatar
        className={styles.pusherAvatar}
        src={pusher.primaryAvatarUrl}
        square={pusher.path.startsWith('/apps/')}
      />
      {pusher.login}
    </Link>
  )
}
